import React, { Component } from "react";
import Split from "grommet/components/Split";
import Box from "grommet/components/Box";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import Table from "grommet/components/Table";
import TableRow from "grommet/components/TableRow";
import CustomerInfo from "../../components/CustomerInfo";
import Loader from "../../components/LoaderOverlay";
import logo from "../../assets/pinterest-logo.png";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

const healthData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov"
  ],
  datasets: [
    {
      borderColor: "#7FCEFF",
      borderWidth: 2,
      pointBackgroundColor: "#7FCEFF",
      pointBorderColor: "white",
      pointRadius: 4,
      pointHoverBackgroundColor: "white",
      pointHoverBorderColor: "#7FCEFF",
      pointHoverRadius: 7,
      pointHitRadius: 6,
      fill: false,
      label: "Churn",
      data: [2.5, 2.3, 2.9, 2.4, 3.5, 2.3, 3.5, 2.5, 2.2, 3.0, 2.9, 2.4]
    }
  ]
};

const healthOptions = {
  legend: {
    display: false,
    labels: {
      boxWidth: 80,
      fontColor: "#696969"
    }
  },
  tooltips: {
    displayColors: false,
    borderColor: "#E6F2F9",
    borderWidth: 1,
    backgroundColor: "white",
    titleFontColor: "#696969",
    titleSpacing: 10,
    titleFontSize: 15,
    bodyFontColor: "#696969",
    bodyFontSize: 11,
    xPadding: 20,
    yPadding: 20
  },
  scales: {
    xAxes: [
      {
        ticks: {
          fontSize: 10,
          fontColor: "#696969"
        },
        gridLines: {
          display: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontSize: 10,
          stepSize: 2,
          max: 10,
          fontColor: "#696969",
          beginAtZero: true,
          callback: function(label, index, labels) {
            return label + " %";
          }
        },
        gridLines: {
          color: "#E6F2F9",
          zeroLineWidth: 0,
          zeroLineColor: "rgba(0,0,0,0)",
          borderDash: [2, 4, 3, 2],
          borderDashOffset: 3
        }
      }
    ]
  }
};

const productData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov"
  ],
  datasets: [
    {
      borderColor: "#7FCEFF",
      borderWidth: 2,
      pointBackgroundColor: "#7FCEFF",
      pointBorderColor: "white",
      pointRadius: 4,
      pointHoverBackgroundColor: "white",
      pointHoverBorderColor: "#7FCEFF",
      pointHoverRadius: 7,
      pointHitRadius: 6,
      fill: false,
      label: "Churn",
      data: [2.5, 2.3, 2.9, 2.4, 3.5, 2.3, 3.5, 2.5, 2.2, 3.0, 2.9, 2.4]
    }
  ]
};

const productOptions = {
  legend: {
    display: false,
    labels: {
      boxWidth: 80,
      fontColor: "#696969"
    }
  },
  tooltips: {
    displayColors: false,
    borderColor: "#E6F2F9",
    borderWidth: 1,
    backgroundColor: "white",
    titleFontColor: "#696969",
    titleSpacing: 10,
    titleFontSize: 15,
    bodyFontColor: "#696969",
    bodyFontSize: 11,
    xPadding: 20,
    yPadding: 20
  },
  scales: {
    xAxes: [
      {
        ticks: {
          fontSize: 10,
          fontColor: "#696969"
        },
        gridLines: {
          display: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontSize: 10,
          stepSize: 2,
          max: 10,
          fontColor: "#696969",
          beginAtZero: true,
          callback: function(label, index, labels) {
            return label + " %";
          }
        },
        gridLines: {
          color: "#E6F2F9",
          zeroLineWidth: 0,
          zeroLineColor: "rgba(0,0,0,0)",
          borderDash: [2, 4, 3, 2],
          borderDashOffset: 3
        }
      }
    ]
  }
};

const ChartTitle = styled.div`
  text-transform: uppercase;
  margin-bottom: 15px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #696969;
  letter-spacing: -0.05px;
  line-height: 20px !important;
`;

const UserTable = styled(Table)`
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #696969;

  th {
    font-weight: 700;
    text-transform: uppercase;
  }
`;

class CustomerDetails extends Component {
  render() {
    console.log("the props are -> ", this.props);

    if (this.props.data.loading) {
      return <Loader />;
    } else {
      return (
        <div>
          <Split fixed={false} flex="right">
            <Box
              direction="column"
              pad="medium"
              style={{
                margin: "12px",
                width: "300px",
                borderRadius: "5px",
                boxShadow: "0 2px 12px 0 rgba(218,218,218,0.50)"
              }}
            >
              <CustomerInfo
                logo={logo}
                title={"Pinterest"}
                customerData={this.props.data.customer}
              />
            </Box>
            <Box justify="center" direction="column" pad="small">
              <Box
                justify="center"
                direction="column"
                pad="medium"
                style={{
                  borderRadius: "5px",
                  boxShadow: "0 2px 12px 0 rgba(218,218,218,0.50)"
                }}
              >
                <Box
                  justify="center"
                  direction="column"
                  pad="none"
                  style={{ borderRadius: "5px", marginBottom: "30px" }}
                >
                  <ChartTitle>Health</ChartTitle>
                  <Line options={healthOptions} data={healthData} />
                </Box>
                <Box
                  justify="center"
                  direction="column"
                  pad="none"
                  style={{ borderRadius: "5px" }}
                >
                  <ChartTitle>Product Usage</ChartTitle>
                  <Line options={productOptions} data={productData} />
                </Box>
              </Box>
              <Box
                justify="center"
                direction="column"
                pad="medium"
                style={{
                  marginTop: "20px",
                  borderRadius: "5px",
                  boxShadow: "0 2px 12px 0 rgba(218,218,218,0.50)"
                }}
              >
                <ChartTitle>Users</ChartTitle>
                <UserTable selectable={true}>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Name</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    <TableRow>
                      <td>1</td>
                      <td>Alan</td>
                      <td className="secondary">plays accordion</td>
                    </TableRow>
                  </tbody>
                </UserTable>
              </Box>
            </Box>
          </Split>
        </div>
      );
    }
  }
}

const CUSTOMER_LIST_QUERY = gql`
  query customer($customerId: ID!) {
    customer(id: $customerId) {
      id
      email
      monthly_amount
      usage_health_score
      stripe_customer_id
    }
  }
`;

const CustomerDetailsWithData = graphql(CUSTOMER_LIST_QUERY, {
  options: props => ({ variables: { customerId: props.match.params.id } })
})(CustomerDetails);

export default CustomerDetailsWithData;



// WEBPACK FOOTER //
// ./src/containers/loggedIn/customerDetails.js